import { Component, OnInit, Inject } from "@angular/core";
import { identifierModuleUrl } from "@angular/compiler";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder } from "@angular/forms";
import {
  DgHubClientService,
  SettingsRequest,
  Settings,
  ViewSettingsReq,
  Views,
  StorePriceRangeReq,
} from "src/app/Services/dg-hub-client.service";
import { DrawingService } from "src/app/Services/DrawingService";
import { CookiesService } from "src/app/Services/cookieService";
import { StoreScaleRangeReq } from "../../Services/dg-hub-client.service";

@Component({
  selector: "app-viewsSelector-dialog",
  templateUrl: "./viewsSelector.component.html",
  styleUrls: ["./viewsSelector.component.css"],
})
export class ViewsSelectorComponent implements OnInit {
  private _views: Views[];
  public get views(): Views[] {
    return this._views;
  }
  public set views(value: Views[]) {
    this._views = value;
  }

  private _disabled: boolean = true;
  public get disabled(): boolean {
    return (
      this.settingsForm.controls["viewName"].value == null ||
      this.settingsForm.controls["viewName"].value == ""
    );
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(
    public dgCLientService: DgHubClientService,
    public drawingService: DrawingService,
    private fb: FormBuilder,
    private cookieService: CookiesService
  ) {
    this.drawingService.newViewResponse.subscribe((v) => {
      this.views = v.views;
    });
  }

  settingsForm = this.fb.group({
    selectedview: [null],
  });

  ngOnInit() {
    this.dgCLientService.GetViewsList().then((v) => {
      this.views = v.views;
    });
  }

  onChange(selectedView) {
    selectedView = selectedView == "null" ? null : selectedView;
    let loadedViewName = selectedView == null ? "Default" : selectedView;

    this.drawingService.loaded = false;
    this.drawingService.loadedItem = `View: ${loadedViewName}`;
    jQuery(".rItem").remove();
    jQuery(".priceLineHandler").remove();
    jQuery(".priceLineHandlerClose").remove();
    jQuery(".priceLineHandlerConfig").remove();

    this.drawingService.annotations.annotationPriceLines.priceLines = [];

    this.dgCLientService.SelectView(selectedView).then(() => {
      this.drawingService.settingsService.loadLocalSettingsForView(selectedView);
      this.drawingService.settingsService.loadLocalSettingsForEvents(selectedView);
      this.drawingService.settingsService.loadLocalSettingsForChartEvent(selectedView);
      this.drawingService.selectedViewName = selectedView;
      this.cookieService.setCookie("_view", selectedView, 1000, "/");
      
      //  this.drawingService.isSelectorAction = true;
      //this.drawingService.route.navigate(['/'], { queryParams: { viewId: selectedView }});
    });
  }
}
